<template>
  <div class="chartdiv" ref="chartdiv" />
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

const data = [{
  category: "Агрикалчер Кубань",
  crop4: 2222,
  crop5: 25000,
  yachmen: 8000,
  crop3: null,
  kukuruza: null
}, {
  category: "Зерно-трейд",
  crop4: 42663,
  crop5: 21000,
  yachmen: null,
  crop3: 7000,
  kukuruza: null
}, {
  category: "Агрикалчер Ростов",
  crop4: 24167,
  crop5: null,
  yachmen: null,
  crop3: null,
  kukuruza: null
}];

export default {
  data() {
    return {
      chart: null
    };
  },

  mounted() {
    const chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart);

    chart.paddingRight = 20;
    chart.data = data;

    // Create axes
    const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "category";
    categoryAxis.title.text = "Терминалы";
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.minGridDistance = 20;

    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.title.text = "Грузооборот, т";

    // Create series
    const series = chart.series.push(new am4charts.ColumnSeries());
    series.dataFields.valueY = "crop4";
    series.dataFields.categoryX = "category";
    series.name = "Пшеница 4 класс";
    series.tooltipText = "{name}: [bold]{valueY}[/]";
    series.stacked = true;

    const series2 = chart.series.push(new am4charts.ColumnSeries());
    series2.dataFields.valueY = "crop5";
    series2.dataFields.categoryX = "category";
    series2.name = "Пшеница 5 класс";
    series2.tooltipText = "{name}: [bold]{valueY}[/]";
    series2.stacked = true;

    const series3 = chart.series.push(new am4charts.ColumnSeries());
    series3.dataFields.valueY = "yachmen";
    series3.dataFields.categoryX = "category";
    series3.name = "Ячмень";
    series3.tooltipText = "{name}: [bold]{valueY}[/]";
    series3.stacked = true;

    const series4 = chart.series.push(new am4charts.ColumnSeries());
    series4.dataFields.valueY = "crop3";
    series4.dataFields.categoryX = "category";
    series4.name = "Пшеница 3 класс";
    series4.tooltipText = "{name}: [bold]{valueY}[/]";
    series4.stacked = true;

    const series5 = chart.series.push(new am4charts.ColumnSeries());
    series5.dataFields.valueY = "kukuruza";
    series5.dataFields.categoryX = "category";
    series5.name = "Кукуруза";
    series5.tooltipText = "{name}: [bold]{valueY}[/]";
    series5.stacked = true;

    // Add legend
    chart.legend = new am4charts.Legend();
    chart.legend.position = 'right';
    chart.legend.maxWidth = undefined;

    this.chart = chart;
  },

  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  }
}
</script>

<style scoped>
.chartdiv {
  width: 1200px;
  height: 500px;
}
</style>